import {
  PanTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";

export const MOUSE_ASSIGNABLE_TOOL_NAMES = [
  StackScrollTool.toolName,
  WindowLevelTool.toolName,
  ZoomTool.toolName,
  PanTool.toolName,
];

export const DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS = {
  primary: StackScrollTool.toolName,
  secondary: WindowLevelTool.toolName,
  auxiliary: PanTool.toolName,
};

export const MOUSE_ASSIGNMENTS_STORAGE_KEY =
  "augmento.basicViewer.mouseButtonToolAssignments";

export function normalizeMouseButtonToolAssignments(raw) {
  const out = {
    primary: DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS.primary,
    secondary: DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS.secondary,
    auxiliary: DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS.auxiliary,
  };
  if (!raw || typeof raw !== "object") {
    return out;
  }
  ["primary", "secondary", "auxiliary"].forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(raw, key)) {
      return;
    }
    const v = raw[key];
    if (v === null || v === undefined) {
      out[key] = null;
    } else if (MOUSE_ASSIGNABLE_TOOL_NAMES.includes(v)) {
      out[key] = v;
    }
  });
  return out;
}

export function loadMouseButtonToolAssignments() {
  try {
    localStorage.removeItem(MOUSE_ASSIGNMENTS_STORAGE_KEY);
  } catch {
  }
  return { ...DEFAULT_MOUSE_BUTTON_TOOL_ASSIGNMENTS };
}

export function saveMouseButtonToolAssignments(assignments) {
  try {
    localStorage.setItem(
      MOUSE_ASSIGNMENTS_STORAGE_KEY,
      JSON.stringify(assignments)
    );
  } catch {
  }
}
